<template>
  <router-view />
</template>
<script>
export default {
  name: "biCockpit",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.biCockpit {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
</style>
